import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { ShowAlert, showConfirmationDialog } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
import { UserRoleEnum } from "../../stores/index.d";
import { useMemo, useState } from "react";
import ChangePasswordAdmin from "./change-password-admin";

const cols: string[] = ["#", "Name", "Email", "Phone", "Role", "Actions"];

interface IUserListing {
  users: IUserCommand[];
  isCustomerPageRequest: boolean;
}

const UserListing = observer(
  ({ users, isCustomerPageRequest }: IUserListing) => {
    const { userStore } = useStores();
    const { fetchUsers, setEditUser, deleteUser } = userStore;
    const [changePwdUser, setChangePwdUser] = useState({
      userId: "",
      userName: "",
    });
    const [showChangePwdModal, setShowChangePwdModal] =
      useState<boolean>(false);

    const tblCols = useMemo(() => {
      if (isCustomerPageRequest) {
        var i = cols.indexOf("Role");
        return cols.filter((_, index) => index !== i);
      } else return cols;
    }, []);

    const handleDelete = (userId: string) => {
      showConfirmationDialog(() => {
        deleteUser(userId, (res: boolean) => {
          if (res) {
            ShowAlert.Success("User deleted successfully.");
            fetchUsers();
          } else ShowAlert.Error("Request failed. Please try again.");
        });
      });
    };

    return (
      <>
        <table className="table table-responsive table-striped shadow-lg">
          <thead>
            <tr>
              {tblCols.map((c, i) => (
                <th
                  scope="col"
                  className="border-top-0 border-start-0 border-end-0 border-3 border-warning"
                  key={i}
                >
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users?.map((user, i) => {
              return (
                <tr key={i}>
                  <th scope="row">{i + 1}</th>
                  <td>{user.surname + ", " + user.firstName}</td>
                  <td>{user.email}</td>
                  <td>{user.phoneNumber ?? "-"}</td>
                  {!isCustomerPageRequest && (
                    <td>{user.roles.map((r) => r)}</td>
                  )}
                  <td>
                    <div className="btn-group">
                      <button className="btn" onClick={() => setEditUser(user)}>
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="text-primary"
                        />
                      </button>
                      {!isCustomerPageRequest &&
                        !user.roles.some((r) => r === UserRoleEnum.Admin) && (
                          <>
                            <button
                              className="btn"
                              onClick={() => {
                                setShowChangePwdModal(true);
                                setChangePwdUser({
                                  userId: user.id,
                                  userName: `${user.surname}, ${user.firstName}`,
                                });
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faUserSecret}
                                className="text-dark"
                              />
                            </button>
                            <button
                              className="btn"
                              onClick={() => handleDelete(user.id)}
                            >
                              <FontAwesomeIcon
                                icon={faTrash}
                                className="text-danger"
                              />
                            </button>
                          </>
                        )}
                    </div>
                  </td>
                </tr>
              );
            })}
            {!users?.length && (
              <tr>
                <th colSpan={5} className="text-center">
                  No data available.
                </th>
              </tr>
            )}
          </tbody>
        </table>
        {showChangePwdModal && changePwdUser?.userId && (
          <ChangePasswordAdmin
            user={changePwdUser}
            show={showChangePwdModal}
            setShowModal={(show: boolean) => setShowChangePwdModal(show)}
          />
        )}
      </>
    );
  }
);

export default UserListing;
